import { DateTime } from 'luxon';

var MFObservableKey;
(function (MFObservableKey) {
  MFObservableKey["PUBLISHER"] = "Publisher";
  MFObservableKey["SUBSCRIBER"] = "Subscriber";
})(MFObservableKey || (MFObservableKey = {}));
/**
 * Enum for the role of the observable.
 *
 * To communicate, a 'REMOTE' observable of a project has to be linked to
 * a 'HOST' observable of another project.
 */
var MFObservableRole;
(function (MFObservableRole) {
  MFObservableRole[MFObservableRole["REMOTE"] = 0] = "REMOTE";
  MFObservableRole[MFObservableRole["HOST"] = 1] = "HOST";
})(MFObservableRole || (MFObservableRole = {}));
/**
 * Enum for the type of the observable.
 *
 * A 'PUBLISHER' observable only pushes event.
 *
 * A 'SUBSCRIBER' observable only subscribes to receive event from a 'PUBLISHER' observable.
 *
 * A 'BOTH' observable has both of inner observables.
 */
var MFObservableType;
(function (MFObservableType) {
  MFObservableType[MFObservableType["PUBLISHER"] = 0] = "PUBLISHER";
  MFObservableType[MFObservableType["SUBSCRIBER"] = 1] = "SUBSCRIBER";
  MFObservableType[MFObservableType["BOTH"] = 2] = "BOTH";
})(MFObservableType || (MFObservableType = {}));

function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function (t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function (t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw new Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(typeof e + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function (e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function () {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function (e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw new Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function (t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function (t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    catch: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function (e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : String(i);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

var EVENTS = '__events__';
var SHARED = '__shared__';
var OBSERVERS = '__observers__';
var Observable = /*#__PURE__*/function () {
  function Observable(namespace) {
    this.dispatch = this.publish;
    Observable.initialize();
    this.namespace = namespace;
  }
  // istanbul ignore next
  Observable.initialize = function initialize() {
    if (!window[SHARED]) {
      var _window$SHARED;
      window[SHARED] = (_window$SHARED = {}, _window$SHARED[EVENTS] = {}, _window$SHARED[OBSERVERS] = {}, _window$SHARED);
    }
    if (!window[SHARED][EVENTS]) {
      window[SHARED][EVENTS] = {};
    }
    if (!window[SHARED][OBSERVERS]) {
      window[SHARED][OBSERVERS] = {};
    }
  };
  var _proto = Observable.prototype;
  _proto.getObservers = function getObservers() {
    return window[SHARED][OBSERVERS][this._namespace];
  };
  _proto.getEvents = function getEvents() {
    return this.events;
  };
  _proto.getLastEvent = function getLastEvent() {
    var events = this.events;
    if (!events.length) {
      return;
    }
    return events[events.length - 1];
  };
  _proto.publish = function publish(data) {
    var events = this.events;
    var lastEvent = this.getLastEvent();
    this.observers.forEach(function (observer) {
      return observer(data, {
        events: events,
        lastEvent: lastEvent
      });
    });
    this.events.push(data);
  };
  _proto.subscribe = function subscribe(observer) {
    this.observers = this.observers.concat(observer);
  };
  _proto.unsubscribe = function unsubscribe(observer) {
    var lengthBefore = this.observers.length;
    this.observers = this.observers.filter(function (obs) {
      return obs !== observer;
    });
    if (lengthBefore === this.observers.length) {
      console.warn("No observer has been unsubscribe. observer :: " + observer);
    }
  };
  _proto.clear = function clear() {
    var events = this.events;
    var lastEvent = this.getLastEvent();
    this.observers.forEach(function (observer) {
      return observer(undefined, {
        events: events,
        lastEvent: lastEvent
      });
    });
    this.events = [];
    this.observers = [];
  };
  _createClass(Observable, [{
    key: "namespace",
    set: function set(namespace) {
      this._namespace = namespace;
      // istanbul ignore next
      if (!this.events) this.events = [];
      // istanbul ignore next
      if (!this.observers) this.observers = [];
    }
  }, {
    key: "events",
    get: function get() {
      return window[SHARED][EVENTS][this._namespace];
    },
    set: function set(newEvents) {
      window[SHARED][EVENTS][this._namespace] = newEvents;
    }
  }, {
    key: "observers",
    get: function get() {
      return window[SHARED][OBSERVERS][this._namespace];
    },
    set: function set(newObservers) {
      window[SHARED][OBSERVERS][this._namespace] = newObservers;
    }
  }]);
  return Observable;
}();

/**
 * Abstract MFObservable class.
 *
 * This class manages all the publish / subscribe behaviors of the MFObservable.
 *
 * Four main methods to use :
 * * **init** : allows to initialize the observable with some parameters and callback usable from the observable implementation.
 * * **publish** : allows to send new data to external subscribers. No wait response.
 * * **publishAndWaitResponse** : allows to send nes data to external subscribers, but wait a response before to continue.
 * * **subscribe** : allows to receive new data from external projects and apply them to this project.
 *
 * **NOTE :**
 * With Module Federation off, publish/subscribe methods calls inner methods (implemented into each kind of MFObservable),
 * to manage differently the data.
 */
var ObservableWrapperAbstract = /*#__PURE__*/function () {
  /**
   * Constructor
   * @param params - {@link MFObservableParams} parameters of the MFObservable
   */
  function ObservableWrapperAbstract(params) {
    this._id = 'TMZ_';
    this._isMFMode = false;
    this._isVerboseMode = false;
    this._id = this._id + params.id;
    this._type = params.type === undefined ? MFObservableType.BOTH : params.type;
    this._role = params.role === undefined ? MFObservableRole.REMOTE : params.role;
    this._needsInitialization = params.needsInitialization === true;
    this._isVerboseMode = params.verboseMode ? params.verboseMode : false;
    if (this.isPublisher()) {
      this._publisherKey = this._id + (this.isHost() ? MFObservableKey.SUBSCRIBER : MFObservableKey.PUBLISHER);
      this._publisherObservable = new Observable(this._publisherKey);
    }
    if (this.isSubscriber()) {
      this._subscriberKey = this._id + (this.isHost() ? MFObservableKey.PUBLISHER : MFObservableKey.SUBSCRIBER);
      this._subscriberObservable = new Observable(this._subscriberKey);
    }
  }
  //===================
  // Main Methods
  //===================
  /**
   * Initialize the observable.
   *
   * @param params - {@link MFObservableInitParam} parameters
   */
  var _proto = ObservableWrapperAbstract.prototype;
  _proto.init = function init(params) {
    this._isMFMode = params.isMFMode;
    this._callback = params.callback;
    this._options = params.options;
    if (this._isMFMode && this.isSubscriber()) {
      if (this._needsInitialization) {
        var _this$_subscriberObse;
        // Then check if there is a last event done to init data
        var lastEvent = (_this$_subscriberObse = this._subscriberObservable) == null ? void 0 : _this$_subscriberObse.getLastEvent();
        this.dataHasBeenChangedWithMF(lastEvent ? lastEvent.data : null);
      }
      if (this.isHost()) {
        this.subscribe();
      }
    }
  }
  /**
   * Main publish method of the MFObservable. This method is called by the project
   * to publish new data.
   *
   * * **MODE Module Federation ON** :
   * Calls the publish method of the "needChange" observable to send the new data to all external subscribers.
   *
   * * **MODE Module Federation OFF** :
   * Calls inner publish method to manage data without the module federation mecanism.
   * These two inner methods have to be implemented on each MFObservable.
   *
   * @param params - {@link MFObservablePublishParam} parameters
   */;
  _proto.publish = function publish(params) {
    if (params === void 0) {
      params = {};
    }
    if (this.isPublisher()) {
      this.log(this._publisherKey, 'Publish');
      if (this._isMFMode) {
        this.publishWithMF(params);
      } else {
        this.publishWithoutMF(params.data);
      }
    }
  }
  /**
   * Main publish method, but waiting a response.
   *
   * @param params - {@link MFObservablePublishParam} parameters
   * @returns a promise
   */;
  _proto.publishAndWaitResponse =
  /*#__PURE__*/
  function () {
    var _publishAndWaitResponse = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(params) {
      var _this = this;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (params === void 0) {
              params = {};
            }
            _context.next = 3;
            return new Promise(function (resolve, reject) {
              // With MF case
              if (_this._isMFMode && _this.isSubscriber()) {
                _this.subscribeWithMF(resolve, reject);
              }
              _this.publish(params);
              // Without MF case
              if (!_this._isMFMode && _this.isSubscriber()) {
                _this.subscribeWithoutMF(resolve, reject);
              }
              // Resolve when publisher
              if (!_this.isSubscriber()) {
                resolve(params.data);
              }
            });
          case 3:
            return _context.abrupt("return", _context.sent);
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    function publishAndWaitResponse(_x) {
      return _publishAndWaitResponse.apply(this, arguments);
    }
    return publishAndWaitResponse;
  }()
  /**
   * Main subscribe method of the MFObservable.
   *
   * * **MODE Module Federation ON** :
   * Calls the subscribe method of the "hasBeenChanged" observable to receive the new data sent by an other project.
   *
   * * **MODE Module Federation OFF** :
   * Calls inner subscribe method to manage data without the module federation mecanism.
   * This inner method has to be implemented on each MFObservable.
   */
  ;
  _proto.subscribe = function subscribe() {
    if (this.isSubscriber()) {
      if (this._isMFMode) {
        this.subscribeWithMF();
      } else {
        this.subscribeWithoutMF();
      }
    }
  }
  //=====================
  // Module Federation ON
  //=====================
  ;
  _proto.publishWithMF = function publishWithMF(params) {
    var _this$_publisherObser;
    (_this$_publisherObser = this._publisherObservable) == null || _this$_publisherObser.publish({
      date: DateTime.utc().toFormat('yyyy-MM-dd HH:mm:ss'),
      data: params.data
    });
  };
  _proto.subscribeWithMF = function subscribeWithMF(resolve, reject) {
    var _this2 = this;
    if (this._subscriberObservable) {
      var subscribeCallback = function subscribeCallback(event) {
        // First, unsusbscribe if we are in a async call
        if (resolve && reject) {
          var _this2$_subscriberObs;
          _this2.log(_this2._subscriberKey, 'Unsubscribe');
          (_this2$_subscriberObs = _this2._subscriberObservable) == null || _this2$_subscriberObs.unsubscribe(subscribeCallback);
        }
        // Then apply received data
        _this2.log(_this2._subscriberKey, 'Subscribe data received');
        _this2.dataHasBeenChangedWithMF(event.data);
        if (resolve && reject) {
          if (event.data) {
            resolve(event.data);
          } else {
            reject(new Error('Subscribe fail : no data returned'));
          }
        }
      };
      this.log(this._subscriberKey, 'Subscribe');
      this._subscriberObservable.subscribe(subscribeCallback);
    } else if (reject) {
      reject(new Error('Subscribe fail : no observable'));
    }
  }
  //===================
  // Helpers
  //===================
  ;
  _proto.isPublisher = function isPublisher() {
    return this._type === MFObservableType.PUBLISHER || this._type === MFObservableType.BOTH;
  };
  _proto.isSubscriber = function isSubscriber() {
    return this._type === MFObservableType.SUBSCRIBER || this._type === MFObservableType.BOTH;
  };
  _proto.isHost = function isHost() {
    return this._role === MFObservableRole.HOST;
  };
  _proto.log = function log(key, text) {
    if (key === void 0) {
      key = '';
    }
    if (this._isVerboseMode) {
      var role = this.isHost() ? 'HOST' : 'REMOTE';
      console.log("[" + role + "][" + key + "](" + text + ")");
    }
  };
  return ObservableWrapperAbstract;
}();

export { MFObservableKey, MFObservableRole, MFObservableType, Observable, ObservableWrapperAbstract };
//# sourceMappingURL=trimoz-windowed-observable.esm.js.map
